import "./hero.css";
import Giffy from "./giffy.gif";

const PageNotFound = () => {
	const restoreApp = (e) => {
		e.preventDefault();
		localStorage.clear();
		window.location.href = "/";
	};

	return (
		<div className="hero__page">
			<div className="hero__container">
				<div className="hero__left">
					<div className="logo" style={{ marginTop: "50px" }}>
						<img src="/img/UBEC-logo.png" alt="logo" width="200" height="200" />
					</div>
					<h1>UBEC WORKFLOW DESK</h1>
					<div style={{ width: "400px", textAlign: "justify" }}>
						<h2 style={{ color: "#901919", marginInline: "20px", textAlign: "left" }}>
							Oops!
						</h2>
						<p
							style={{
								color: "#255B4F",
								fontSize: "24px",
								marginInline: "20px",
								textAlign: "justify",
								width: "100%",
							}}
						>
							UWD can't seem to find the page you're looking for.
						</p>
					</div>
					<div className="hero__cta__btns">
						<button className="cta__btn1" onClick={(e) => restoreApp(e)}>
							Go to Home
						</button>
						<button className="cta__btn2" onClick={(e) => restoreApp(e)}>
							Refresh Page
						</button>
					</div>
				</div>
				<div className="hero__right">
					<img
						src={Giffy}
						alt="404-header"
						style={{ width: "600px", height: "6 00px" }}
					/>
				</div>
			</div>
		</div>
	);
};

export default PageNotFound;
